import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import Navbar from "../../../components/Navbar";
import { tokens, GET, PUT, getStorage, format_date, success_url, loading } from "../../../components/CustomComponent.js";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import LOGO from "../../../assets/images/logo.png";
import Switch from "react-switch";

export default class Letter extends Component {
  state = {
    modal_text: false, text: "", type: "", document_data: null,
    setting: {
      header_1: { status: true, title: "-โลโก้" }, header_2: { status: true, title: "" }, header_3: { status: true, title: "" },
      header_4: { status: true, title: "-วันที่" }, header_5: { status: true, title: "เรื่อง" }, header_6: { status: true, title: "-เรียน" },
      header_7: { status: true, title: "" }, th_1: { status: true, title: "-รายการ" }, th_2: { status: true, title: "-เดือน" },
      th_3: { status: true, title: "-ราคา" }, tr_1: { status: true, title: "-ค่าน้ำประปา" }, tr_2: { status: true, title: "-ค่ารักษาอุปกรณ์น้ำ" },
      tr_3: { status: true, title: "-ค่าจัดเก็บขยะ" }, tr_4: { status: true, title: "-ค่าใช้จ่ายส่วนกลาง" }, tr_5: { status: true, title: "-อื่นๆ" },
      tr_6: { status: true, title: "-ค่าค้างชำระ" }, tr_7: { status: true, title: "-ค่าเบี้ยปรับ" }, tr_8: { status: true, title: "-รวมเป็นเงินทั้งสิ้น" },
      footer_1: { status: true, title: "" }, footer_2: { status: true, title: "-ขอแสดงความนับถือ" }, footer_3: { status: true, title: "" },
      footer_4: { status: true, title: "" }, footer_5: { status: true, title: "" },
    },
  };

  async componentDidMount() {
    loading(false); // ปิด Loading ทันทีที่เข้าหน้าแรก
    await this.Get();
  }

  Get = async () => {
    loading(true);
    let r = await GET(tokens, `v1/TH/document-manage/detail/custom-document/${getStorage("project_id")}`, null);
    if (r?.status) {
      this.setState({ document_data: r.data.data, setting: r.data.data.letter || this.state.setting });
    }
    loading(false);
  };

  Update = async () => {
    loading(true);
    let r = await PUT(tokens, "v1/TH/document-manage/update/custom-document", { ...this.state.document_data, letter: this.state.setting });
    if (r?.status) success_url("/letter");
    loading(false);
  };

  UpdateStatus = (type) => this.setState(prev => ({ setting: { ...prev.setting, [type]: { ...prev.setting[type], status: !prev.setting[type].status } } }));

  // Helper Functions ช่วยย่อ UI
  dNone = (key) => this.state.setting[key]?.status ? "" : " d-none";
  
  renderSwitch = (label, key, hasEdit = false) => (
    <div className="d-flex flex-wrap mb-1">
      <div className={`wpx-140${hasEdit ? " d-flex" : ""}`}>
        {label}
        {hasEdit && (
          <label className="wpx-20 hpx-20 bg-warning-light rounded-1 d-flex align-items-center justify-content-center icon text-warning pointer mx-1"
            onClick={() => this.setState({ modal_text: true, text: this.state.setting[key].title, type: key })}>{"\uf304"}</label>
        )}
      </div>
      <Switch height={20} width={40} checked={this.state.setting[key].status} onChange={() => this.UpdateStatus(key)} />
    </div>
  );

  render() {
    const s = this.state.setting;
    const trData = [
      { k: "tr_1", n: "1. ค่าน้ำประปา" }, { k: "tr_2", n: "2. ค่ารักษาอุปกรณ์การใช้น้ำ" },
      { k: "tr_3", n: "3. ค่าบริการจัดเก็บขยะ" }, { k: "tr_4", n: "4. ค่าใช้จ่ายส่วนกลาง" },
      { k: "tr_5", n: "5. อื่นๆ" }, { k: "tr_6", n: "6. ค่าค้างชำระ 0 งวด", em: true },
      { k: "tr_7", n: "7. ค่าเบี้ยปรับ", em: true },
    ];

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="จดหมายแจ้งเตือน" />
        <div className="body">
          <div className="p-3">
            <h4><b>จดหมายแจ้งเตือน</b></h4>
            <div className="d-flex">
              <div style={{ width: 816.38 }}>
                <div className="mx-auto bg-white p-5 pdf-large border-bottom" style={{ width: 1116, height: 1578, zoom: 0.75 }}>
                  <div className="p-4">
                    <div className="w-100 d-flex justify-content-between">
                      <div className="d-flex align-items-center">
                        <img src={getStorage("picture_paper") || LOGO} style={{ width: 100, height: 100, objectFit: "contain", marginRight: 6 }} alt="LOGO" className={`bg-contain mb-4${this.dNone("header_1")}`} />
                        <div>
                          <h2 className={`fw-bold px-2 mb-0${this.dNone("header_2")}`}>{s.header_2.title}</h2>
                          <div className={`px-2 mb-4${this.dNone("header_3")}`}>{s.header_3.title.split("\n").map((e, i) => (<div key={i}>{e}</div>))}</div>
                        </div>
                      </div>
                      <div className={`wpx-250 text-right mb-4${this.dNone("header_4")}`}>วันที่ : {format_date(new Date(), "dd mmmm yyyy")}</div>
                    </div>
                    <div className={`mb-4${this.dNone("header_5")}`}>เรื่อง : แจ้งเตือนให้ชำระค่าใช้จ่ายตามข้อบังคับ</div>
                    <div className={`mb-4${this.dNone("header_6")}`}>เรียน : นายสมมติ นามสกุลสมมติ ห้องเลขที่ 123/45 อาคารเลขที่ 6 ต.หายยา อ.เมืองเชียงใหม่ จ.เชียงใหม่ 50100</div>
                    <div className={`mb-4${this.dNone("header_7")}`} style={{ textIndent: 80 }}>{s.header_7.title}</div>
                    
                    <table className="table table-borderless mb-4">
                      <tbody>
                        {trData.map(t => (
                          <tr key={t.k} className={this.dNone(t.k)}>
                            <td className={`w-100${this.dNone("th_1")}`}>{t.n}</td>
                            <td className={`w-100 text-nowrap pr-5${this.dNone("th_2")}`}>{!t.em ? `เดือน ${format_date(new Date(), "mmmm yyyy")}` : ""}</td>
                            <td className={`text-nowrap wpx-350${this.dNone("th_3")}`}>
                              <div className="d-flex justify-content-end p-0">เป็นเงิน <div className="wpx-150 text-right pr-3">0.00</div> บาท</div>
                            </td>
                          </tr>
                        ))}
                        <tr className={this.dNone("tr_8")}>
                          <td className={`w-100${this.dNone("th_1")}`} /><td className={`w-100 text-nowrap pr-5${this.dNone("th_2")}`} />
                          <td className={`text-nowrap wpx-350${this.dNone("th_3")}`}>
                            <div className="d-flex justify-content-end p-0">รวมเป็นเงินทั้งสิ้น <div className="wpx-150 text-right pr-3">0.00</div> บาท</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className={`mb-4${this.dNone("footer_1")}`} style={{ textIndent: 80 }}>{s.footer_1.title}</div>
                    <div className="w-50 ml-auto text-center">
                      <div className={`text-center w-100 mt-5${this.dNone("footer_2")}`}>ขอแสดงความนับถือ</div>
                      <div className={`text-center w-100${this.dNone("footer_3")}`}>({s.footer_3.title})</div>
                      <div className={`text-center w-100 mb-5${this.dNone("footer_4")}`}>{s.footer_4.title}</div>
                    </div>
                    <div className={`mb-4${this.dNone("footer_5")}`}>หมายเหตุ : {s.footer_5.title.split("\n").map((e, i) => (<div key={i}>{e}</div>))}</div>
                  </div>
                </div>
              </div>

              {/* การตั้งค่า (ขวา) */}
              <div className="px-3">
                <div className="w-100 bg-white d-flex flex-wrap mb-auto">
                  <div className="py-3 px-4">
                    <h5 className="fw-bold">หัวเอกสาร</h5>
                    {this.renderSwitch("โลโก้", "header_1")}
                    {this.renderSwitch("โครงการ", "header_2", true)}
                    {this.renderSwitch("ที่อยู่", "header_3", true)}
                    {this.renderSwitch("วันที่", "header_4")}
                    {this.renderSwitch("เรื่อง", "header_5")}
                    {this.renderSwitch("เรียน", "header_6")}
                    {this.renderSwitch("รายละเอียดส่วนหัว", "header_7", true)}
                  </div>
                  <div className="py-3 px-4">
                    <h5 className="fw-bold">หัวตาราง</h5>
                    {this.renderSwitch("รายการ", "th_1")}
                    {this.renderSwitch("เดือน", "th_2")}
                    {this.renderSwitch("ราคา", "th_3")}
                  </div>
                  <div className="py-3 px-4">
                    <h5 className="fw-bold">ข้อมูลในตาราง</h5>
                    {this.renderSwitch("ค่าน้ำประปา", "tr_1")}
                    {this.renderSwitch("ค่ารักษาอุปกรณ์น้ำ", "tr_2")}
                    {this.renderSwitch("ค่าจัดเก็บขยะ", "tr_3")}
                    {this.renderSwitch("ค่าใช้จ่ายส่วนกลาง", "tr_4")}
                    {this.renderSwitch("อื่นๆ", "tr_5")}
                    {this.renderSwitch("ค่าค้างชำระ", "tr_6")}
                    {this.renderSwitch("ค่าเบี้ยปรับ", "tr_7")}
                    {this.renderSwitch("รวมเป็นเงินทั้งสิ้น", "tr_8")}
                  </div>
                  <div className="py-3 px-4">
                    <h5 className="fw-bold">footer</h5>
                    {this.renderSwitch("รายละเอียดส่วนท้าย", "footer_1", true)}
                    {this.renderSwitch("ขอแสดงความนับถือ", "footer_2")}
                    {this.renderSwitch("ชื่อผู้ออกใบแจ้ง", "footer_3", true)}
                    {this.renderSwitch("ตำแหน่ง", "footer_4", true)}
                    {this.renderSwitch("หมายเหตุ", "footer_5", true)}
                  </div>
                </div>
                <div className="bg-white p-3"><button className="btn btn-primary w-100" onClick={this.Update}>บันทึก</button></div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={this.state.modal_text} onHide={() => this.setState({ modal_text: false })}>
          <Modal.Header><Modal.Title><b>แก้ไข</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-start mb-3">
              <label className="wpx-50">หัวข้อ :</label>
              <textarea className="form-control border-0 bg-contain validate" rows={5} placeholder="กรอกข้อมูล" onChange={(e) => this.setState({ text: e.target.value })} value={this.state.text} />
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_text: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={() => {
                  let set = { ...this.state.setting };
                  set[this.state.type].title = this.state.text;
                  this.setState({ setting: set, modal_text: false });
                }}>บันทึก</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}